/**
 * Cavilow brand logo wordmark + symbol.
 * Uses the uploaded logo asset from /public.
 */
export default function CavilowLogo({ size = 36, showText = true, textClass = "" }) {
  return (
    <span className="inline-flex items-center gap-2">
      <img
        src="/cavilow-logo.png"
        alt="Cavilow"
        width={size}
        height={size}
        className="object-contain shrink-0"
        style={{ width: size, height: size }}
      />
      {showText && (
        <span className={`font-display font-black tracking-tight ${textClass}`}>
          Cavilow
        </span>
      )}
    </span>
  );
}
